import { render, staticRenderFns } from "./NotCertified.vue?vue&type=template&id=3423fe17&scoped=true"
import script from "./NotCertified.vue?vue&type=script&lang=js"
export * from "./NotCertified.vue?vue&type=script&lang=js"
import style0 from "./NotCertified.vue?vue&type=style&index=0&id=3423fe17&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3423fe17",
  null
  
)

export default component.exports